// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { string, object, oneOfType } from 'prop-types'

const LabelSimple = ({ label, idRoot }) => (
  label
    ? (
      <label
        className={'label'}
        id={`${idRoot}-label`}>
        {label}
      </label>
    ) : null
)

LabelSimple.propTypes = {
  label: oneOfType([
    string,
    object,
  ]),
  idRoot: string.isRequired,
}

export default LabelSimple
